// Sesion del portal. La implementacion es la compartida (@ucorp/web-auth);
// aca queda lo que es del portal: su clave de storage, distinta de la de la
// torre aunque cada SPA viva en su propio dominio y no comparta storage.
import { createSessionStore, sessionValid, type WebSession } from "@ucorp/web-auth";

const CLAVE = "ucorp.portal.sesion";

export type PortalSession = WebSession;

/** Store del portal. Lo comparte renewal.ts: una sola sesion en memoria. */
export const store = createSessionStore(CLAVE);

export { sessionValid };

export function guardarSesion(session: PortalSession): void {
  store.guardar(session);
}

/** Borra memoria (refresh token incluido) y storage. */
export function borrarSesion(): void {
  store.borrar();
}

export function leerSesion(now: number = Date.now()): PortalSession | null {
  return store.leer(now);
}
